import o from "react";
import { c as e, t as a } from "./app-a75c1d35.mjs";
import { B as n } from "./Block-9b78bd10.mjs";
import { I as y, a as T } from "./Image-d6406817.mjs";
import { L as B } from "./Link-479ac100.mjs";
import { B as d } from "./Button-c598cb52.mjs";
import { W as I } from "./Icon-3122c134.mjs";
import { u as E } from "./useClickOutside-726e7c36.mjs";
import "./ImageContext-57256dc1.mjs";
import "./Image.module-8b345b58.mjs";
import "./LinkContext-0c83848a.mjs";
const P = "promotion", N = "promotion__background--gray", k = "promotion__lead_text", D = "promotion__save-left-button", L = "promotion__save-left-button__hidden", S = "promotion__save-right-button", C = "desktop", O = "promotion__header_text", H = "promotion__header_text--inverse", R = "promotion__body_text", W = "promotion__body_text--gray-bg", G = "promotion__button", w = "promotion__container", M = "promotion__svg__desktop", z = "promotion__svg__SmallTablet", A = "promotion__svg__LargeTablet", F = "promotion__svg__mobile", V = "promotion__svg__close", U = "promotion__image", j = "promotion__infos", q = "promotion__default-image", J = "promotion__default-container", K = "promotion__default-container-without-margin", Q = "promotion__default-left-image", X = "promotion__default-infos-background", Y = "promotion__default-infos-background--white", Z = "promotion__default-infos-background--dark-blue", $ = "promotion__default-infos", oo = "promotion__default-infos__description", to = "promotion__default-left-infos", eo = "promotion__default-left-infos__description", no = "promotion__campaign--vertical", ro = "promotion__campaign--horizontal", t = {
  promotion: P,
  promotionBackgroundGray: N,
  promotionLeadText: k,
  promotionSaveLeftButton: D,
  promotionSaveLeftButtonHidden: L,
  promotionSaveRightButton: S,
  desktop: C,
  promotionHeaderText: O,
  promotionHeaderTextInverse: H,
  promotionBodyText: R,
  promotionBodyTextGrayBg: W,
  promotionButton: G,
  promotionContainer: w,
  promotionSvgDesktop: M,
  promotionSvgSmallTablet: z,
  promotionSvgLargeTablet: A,
  promotionSvgMobile: F,
  promotionSvgClose: V,
  promotionImage: U,
  promotionInfos: j,
  promotionDefaultImage: q,
  promotionDefaultContainer: J,
  promotionDefaultContainerWithoutMargin: K,
  promotionDefaultLeftImage: Q,
  promotionDefaultInfosBackground: X,
  promotionDefaultInfosBackgroundWhite: Y,
  promotionDefaultInfosBackgroundDarkBlue: Z,
  promotionDefaultInfos: $,
  promotionDefaultInfosDescription: oo,
  promotionDefaultLeftInfos: to,
  promotionDefaultLeftInfosDescription: eo,
  promotionCampaignVertical: no,
  promotionCampaignHorizontal: ro
};
function io({
  leadText: r,
  heading: p,
  body: g,
  imageAlt: u,
  imageData: i,
  link: f,
  linkLocale: l,
  isExternalLink: s = !1,
  btnText: m,
  credits: c
}) {
  return /* @__PURE__ */ o.createElement(
    n,
    {
      className: t.promotionCampaignVertical,
      topPadding: n.Padding.NONE,
      bottomPadding: n.Padding.NONE,
      "data-testid": "promotion-banner-vertical"
    },
    /* @__PURE__ */ o.createElement(
      "div",
      {
        className: e(t.promotionImage),
        "data-testid": "promotion-banner-image"
      },
      /* @__PURE__ */ o.createElement(
        y,
        {
          credits: c,
          src: i.imageSrc,
          width: i.width,
          height: i.height,
          altText: u || "Promotion banner image",
          imageLoader: i.imageLoader,
          styling: T.PROMOTION
        }
      )
    ),
    /* @__PURE__ */ o.createElement(
      n.Content,
      {
        className: t.promotionInfos,
        "data-testid": "promotion-banner-content",
        itemScope: !0,
        itemType: "https://schema.org/Thing",
        flex: !0
      },
      !!r && /* @__PURE__ */ o.createElement(
        "p",
        {
          className: e(
            a.textsComponentTitleBold,
            t.promotionLeadText
          ),
          itemProp: "description"
        },
        r
      ),
      !!p && /* @__PURE__ */ o.createElement(
        "h3",
        {
          className: e(
            a.textsComponentTitleBold,
            t.promotionHeaderText
          ),
          itemProp: "name"
        },
        p
      ),
      /* @__PURE__ */ o.createElement(
        "div",
        {
          className: e(
            a.richText,
            a.textsLeadText,
            t.promotionBodyText
          ),
          itemProp: "description"
        },
        g
      ),
      m && /* @__PURE__ */ o.createElement(
        "div",
        {
          className: t.promotionButton,
          "data-testid": "promotion-banner-action"
        },
        /* @__PURE__ */ o.createElement(
          B,
          {
            className: d.PrimaryFocusStyleInLink,
            href: f,
            locale: l,
            target: s ? "_blank" : void 0,
            disableLinkTextStyle: !0,
            itemProp: "url"
          },
          /* @__PURE__ */ o.createElement(
            d.Primary,
            {
              text: m,
              icon: s ? I.ARROW_UP_RIGHT : void 0,
              asDiv: !0,
              preventEmployerStyle: !0
            }
          )
        )
      )
    )
  );
}
function ao({
  leadText: r,
  heading: p,
  body: g,
  imageAlt: u,
  imageData: i,
  link: f,
  linkLocale: l,
  isExternalLink: s = !1,
  btnText: m,
  credits: c
}) {
  return /* @__PURE__ */ o.createElement(
    n,
    {
      className: t.promotionCampaignHorizontal,
      topPadding: n.Padding.NONE,
      bottomPadding: n.Padding.NONE,
      "data-testid": "promotion-banner-horizontal"
    },
    /* @__PURE__ */ o.createElement(
      n.Content,
      {
        className: e(t.promotionContainer),
        "data-testid": "promotion-banner-container",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      /* @__PURE__ */ o.createElement(
        "div",
        {
          className: e(t.promotionImage),
          "data-testid": "promotion-banner-image"
        },
        /* @__PURE__ */ o.createElement(
          y,
          {
            credits: c,
            src: i.imageSrc,
            width: i.width,
            height: i.height,
            altText: u || "Promotion banner image",
            imageLoader: i.imageLoader,
            styling: T.PROMOTION
          }
        )
      ),
      /* @__PURE__ */ o.createElement(
        "div",
        {
          className: e(t.promotionInfos),
          "data-testid": "promotion-banner-content"
        },
        !!r && /* @__PURE__ */ o.createElement(
          "p",
          {
            className: e(
              a.textsComponentTitleBold,
              t.promotionLeadText
            ),
            itemProp: "description"
          },
          r
        ),
        !!p && /* @__PURE__ */ o.createElement(
          "h3",
          {
            className: e(
              a.textsComponentTitleBold,
              t.promotionHeaderText
            ),
            itemProp: "name"
          },
          p
        ),
        /* @__PURE__ */ o.createElement(
          "div",
          {
            className: e(
              a.richText,
              a.textsLeadText,
              t.promotionBodyText
            ),
            itemProp: "description"
          },
          g
        ),
        m && /* @__PURE__ */ o.createElement(
          "div",
          {
            className: t.promotionButton,
            "data-testid": "promotion-banner-action"
          },
          /* @__PURE__ */ o.createElement(
            B,
            {
              className: d.PrimaryFocusStyleInLink,
              href: f,
              locale: l,
              target: s ? "_blank" : void 0,
              disableLinkTextStyle: !0,
              itemProp: "url"
            },
            /* @__PURE__ */ o.createElement(
              d.Primary,
              {
                text: m,
                icon: s ? I.ARROW_UP_RIGHT : void 0,
                asDiv: !0,
                preventEmployerStyle: !0
              }
            )
          )
        )
      )
    )
  );
}
function mo(r) {
  const {
    heading: p,
    body: g,
    imageAlt: u,
    link: i,
    linkLocale: f,
    btnText: l,
    isExternalLink: s,
    direction: m,
    removeMargin: c,
    imageData: v,
    backgroundColor: _ = "white",
    credits: x
  } = r, h = E(), b = e({
    [t.promotionDefaultInfos]: m === "right",
    [t.promotionDefaultLeftInfos]: m !== "right",
    [t.promotionDefaultInfosBackground]: !h,
    [t.promotionDefaultInfosBackgroundWhite]: h && _ === "gray",
    [t.promotionDefaultInfosBackgroundDarkBlue]: h && _ !== "gray"
  });
  return /* @__PURE__ */ o.createElement(
    n,
    {
      topPadding: n.Padding.NONE,
      bottomPadding: c ? n.Padding.NONE : n.Padding.LARGE,
      className: e(
        t.promotion,
        h && _ === "gray" && t.promotionBackgroundGray
      )
    },
    /* @__PURE__ */ o.createElement(
      n.Content,
      {
        className: e(
          c ? t.promotionDefaultContainerWithoutMargin : t.promotionDefaultContainer
        ),
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      /* @__PURE__ */ o.createElement(
        "div",
        {
          className: e(
            m === "right" ? t.promotionDefaultImage : t.promotionDefaultLeftImage
          ),
          "data-testid": "promotion-banner-image-container"
        },
        /* @__PURE__ */ o.createElement(
          y,
          {
            credits: x,
            src: v.imageSrc,
            width: v.width,
            height: v.height,
            altText: u || "Promotion banner image",
            imageLoader: v.imageLoader,
            styling: T.PROMOTION
          }
        )
      ),
      /* @__PURE__ */ o.createElement(
        "div",
        {
          "data-testid": "promotion-banner-content",
          className: b
        },
        p && /* @__PURE__ */ o.createElement(
          "h3",
          {
            className: e(
              a.textsComponentTitleBold,
              t.promotionHeaderText,
              h && _ !== "gray" && t.promotionHeaderTextInverse
            ),
            itemProp: "name"
          },
          p
        ),
        /* @__PURE__ */ o.createElement(
          "div",
          {
            className: e(
              a.richText,
              a.textsLeadText,
              t.promotionBodyText,
              [_ === "gray" ? "" : t.promotionBodyTextGrayBg]
            ),
            itemProp: "description"
          },
          g
        ),
        l && /* @__PURE__ */ o.createElement(
          "div",
          {
            className: t.promotionButton,
            "data-testid": "promotion-banner-action"
          },
          /* @__PURE__ */ o.createElement(
            B,
            {
              className: d.PrimaryFocusStyleInLink,
              href: i,
              target: s ? "_blank" : void 0,
              locale: f,
              disableLinkTextStyle: !0,
              itemProp: "url"
            },
            /* @__PURE__ */ o.createElement(
              d.Primary,
              {
                text: l,
                icon: s ? I.ARROW_UP_RIGHT : void 0,
                asDiv: !0
              }
            )
          )
        )
      )
    )
  );
}
function To(r) {
  return r.promotionType === "campaign" ? /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(ao, { ...r }), /* @__PURE__ */ o.createElement(io, { ...r })) : /* @__PURE__ */ o.createElement(mo, { ...r });
}
export {
  To as PromotionBanner
};
//# sourceMappingURL=PromotionBanner.js.map
